"use client"

import { BugPlay } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BugPlayIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BugPlayIcon = component(Icon)({ as: BugPlay })
